import styled from '@emotion/styled/macro';
import vars from '@variables';
import { Link } from 'gatsby';
import {
  ALIGN_CONTENT,
  BackgroundProps,
  ContentProps,
} from './single-cta-block.types';
const linkStyles = (useLightText?: boolean) => `
  display: inline-block;
  text-decoration: none;
  border-radius: 4px;
  background-color: ${useLightText ? vars.white : vars.coreDarkGrey};
  color: ${useLightText ? vars.coreDarkGrey : vars.white};
  font-weight: ${vars.fontWeightBold};
  ${vars.fontSize3};
  padding: ${vars.spacingM} ${vars.spacingL};
  margin-right:${vars.spacingM};
  margin-top:${vars.spacingS};
  box-sizing: border-box;
  border: 1px solid ${useLightText ? vars.coreDarkGrey : 'transparent'};
  
  &:nth-of-type(2) {
    margin-right: 0;
    margin-bottom: 0;
    background-color: ${useLightText ? 'transparent' : vars.white};
    color: ${useLightText ? vars.white : vars.coreDarkGrey};
    border: 1px solid ${useLightText ? vars.white : vars.coreDarkGrey};
  }  
`;

const imageStyles = `
position: relative;
  left: 50%;
  margin-left: -50vw;
  width: 100vw;
  height: 800px;
  object-fit: cover;
`;

export const Wrapper = styled.div`
  display: block;
  padding-top: 0;
  padding-bottom: 0;
  position: relative;

  .gatsby-image-pos {
    ${imageStyles}
  }
`;

export const Background = styled.div<BackgroundProps>`
  position: relative;
  left: 50%;
  margin-left: -50vw;
  width: 100vw;
  height: 800px;
  background-color: ${({ bgColor }) => (bgColor ? bgColor : vars.coreDarkGrey)};
`;

export const Image = styled.img`
  ${imageStyles}
`;

export const Content = styled('div', {
  shouldForwardProp: prop =>
    !['useLightText', 'showWhiteBox', 'alignment'].includes(prop),
})<ContentProps>`
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  background-color: ${({ showWhiteBox }) =>
    showWhiteBox ? vars.white : 'transparent'};
  padding: ${({ showWhiteBox }) => (showWhiteBox ? vars.spacingL : 0)};
  border-radius: ${({ showWhiteBox }) => (showWhiteBox ? '16px' : '0px')};
  max-width: 50rem;
  min-width: 31rem;
  width: 70%;
  z-index: 10;

  ${({ alignment }) =>
    alignment === ALIGN_CONTENT.LEFT &&
    `
    @media screen and (min-width: ${vars.breakPointTablet}) {
      transform: translateY(-50%);
      left: unset;     
    }
  `}
  ${({ alignment }) =>
    alignment === ALIGN_CONTENT.RIGHT &&
    `
    @media screen and (min-width: ${vars.breakPointTablet}) {
      transform: translateY(-50%);
      left: unset;
      right: 0;    
    }
  `}
  ${({ alignment }) =>
    alignment === ALIGN_CONTENT.CENTRE &&
    `
    left: 50%;
    transform: translate(-50%, -50%);
  `}

  @media screen and (min-width: ${vars.breakPointTablet}) {
    padding: ${({ showWhiteBox }) => (showWhiteBox ? vars.spacingXl : 0)};
    top: 50%;
  }

  // styles related to rich text
  p,
  span,
  h2,
  h3,
  div {
    color: ${({ useLightText }) =>
      useLightText ? vars.white : vars.coreDarkGrey};
  }
`;

export const Title = styled('h2', {
  shouldForwardProp: prop => prop !== 'useLightText',
})<{ useLightText?: boolean }>`
  font-weight: ${vars.fontWeightBold};
  ${vars.fontSize8};
  letter-spacing: -0.02em;
  margin-bottom: 2rem;
  max-width: 58rem;
  color: ${({ useLightText }) =>
    useLightText ? vars.white : vars.coreDarkGrey};
`;

export const CallToAction = styled(Link, {
  shouldForwardProp: prop => prop !== 'useLightText',
})<{ useLightText?: boolean }>`
  ${({ useLightText }) => linkStyles(useLightText)}
`;

export const ExternalCallToAction = styled('a', {
  shouldForwardProp: prop => prop !== 'useLightText',
})<{ useLightText?: boolean }>`
  ${({ useLightText }) => linkStyles(useLightText)}
  display:inline-flex;
  align-items: center;

  svg {
    bottom: 2px;
    left: 4px;
    position: relative;
  }
`;

export const VideoWrapper = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-left: calc(-50vw + 50%);
  width: 100vw;
  z-index: 1;
  height: 800px;

  .video-image-bg {
    position: absolute;
    left: 0;
    top: 0;
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
    z-index: 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      display: block;
    }
  }

  video {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: transparent;
  }
`;
